import React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import ApplePayButton from './ApplePayButton';  // Import the Apple Pay Button component

// Initialize Stripe with your publishable key
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);

const ApplePay = () => {
  return (
    <Elements stripe={stripePromise}>
      <ApplePayButton />
    </Elements>
  );
};

export default ApplePay;
